import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import { ReactGrandTour } from "react-grand-tour";
import { settingsSteps } from "./onboardingSteps";
import { Button } from "@paylixecommerce/shared/components";
import useMobile from "../hooks/useMobile";


export default (ImportComponent) => (props) => {

	const { pathname } = useLocation();
	const [steps, setSteps] = useState([]);
	const [open, setOpen] = useState(false);
	const history = useHistory();
	const isMobile = useMobile();
	const settings = [
		'/settings/general',
		'/settings/personal',
		'/settings/security',
		'/settings/notifications',
		'/settings/create/shop',

		'/settings/shop/general',
		'/settings/shop/payments',
		'/settings/shop/crypto',
		'settings/shop/cart',
		'/settings/shop/subscription',
		'/settings/shop/design',
		'/settings/shop/managers'
	];
	const isSettings = pathname.includes("/settings/");
	const hash = history.location.hash.substr(1);

	const onClose = () => {
		window.localStorage.setItem("onboardingSettings", "true");
		history.replace({
			hash: ""
		});
	}

	useEffect(() => {
		if(hash === "onboarding") {

			setTimeout(() => {
				if(isMobile) {
					setOpen(false);
				} else {
					setOpen(true);
				}
			}, 500);

		} else {

			setOpen(false);
			history.replace({ hash: `` });

			if(!window.localStorage.getItem("onboardingSettings")) {
				history.replace({
					hash: "#onboarding"
				});
			}

		}
	}, [hash]);


	useEffect(() => {

		setSteps(settingsSteps);

	}, [isSettings, open]);


	return <ReactGrandTour
		steps={steps}
		onClose={onClose}
		open={open}
		openAt={0}
		disableCloseOnEscape
		closeButton={() => <div><i className="fa-regular fa-xmark paylixecommerce-onboarding-close" style={{ fontSize: 30, color: "var(--darkFontColor)" }} /></div>}
		dialogWrapper={(props) => {

			const { changeStep, stepIndex, allSteps } = props;

			const prevStep = () => {
				changeStep(stepIndex - 1);
				history.replace({
					pathname: settings[stepIndex - 1],
					hash: "#onboarding"
				});
			};

			const nextStep = () => {
				changeStep(stepIndex + 1);
				history.replace({
					pathname: settings[stepIndex + 1],
					hash: "#onboarding"
				});
			};

			const skipTour = () => {
				window.localStorage.setItem("onboardingSettings", "true");
				setOpen(false);
				history.replace({ hash: "" });
			};

			const dotStep = (step) => {
				changeStep(step);
				history.replace({
					pathname: settings[step],
					hash: "#onboarding"
				});
			};

			return <div className="paylixecommerce-onboarding-container">
				{props.closeButton}
				<div className="paylixecommerce-onboarding">
					<div style={{paddingRight: "2rem"}}>{props.content}</div>
					<div className="paylixecommerce-onboarding-navigation gap-2 flex-wrap">
						<div style={{ fontWeight: 500, fontSize: 13, whiteSpace: "nowrap" }}>{stepIndex + 1} of {allSteps.length}</div>
						<div className="d-flex gap-2 justify-content-between w-100">
							{(allSteps.length === stepIndex + 1) ? <span /> : <Button variant="secondary" onClick={skipTour}>Skip</Button>}
							<div className="d-flex gap-2">
								{stepIndex === 0 ? null : <Button variant="secondary" onClick={prevStep}>Prev</Button>}
								{(allSteps.length === stepIndex + 1) ? <Button variant="primary" onClick={onClose}>Close</Button> : <Button variant="primary" iconName="arrow-right" iconPosition="right" onClick={nextStep}>Next</Button>}
							</div>
						</div>
					</div>
				</div>

			</div>
		}}
	>
		<ImportComponent {...props} />
	</ReactGrandTour>;
}
